/**
 * Services for logging events directly to the Application Insights ingestion endpoint.
 * Bypasses the AppInsights SDK to keep bundle size minimal.
 */

const connStr = import.meta.env.VITE_APPLICATION_INSIGHTS_CONNECTION_STRING || ''
const iKey = connStr.match(/InstrumentationKey=([^;]+)/)?.[1] || ''
const ingestionEndpoint =
  (connStr.match(/IngestionEndpoint=([^;]+)/)?.[1]?.replace(/\/$/, '') || '') + '/v2/track'

export function logEventToAppInsights(name: string, properties?: Record<string, unknown>): void {
  if (!iKey || !ingestionEndpoint) return

  const envelope = [
    {
      name: `Microsoft.ApplicationInsights.${iKey}.Event`,
      time: new Date().toISOString(),
      iKey,
      data: {
        baseType: 'EventData',
        baseData: {
          ver: 2,
          name,
          properties: { platform: 'web', ...(properties || {}) },
        },
      },
    },
  ]

  const body = JSON.stringify(envelope)

  if (navigator.sendBeacon) {
    navigator.sendBeacon(ingestionEndpoint, body)
  } else {
    fetch(ingestionEndpoint, { method: 'POST', body, keepalive: true }).catch(() => {})
  }
}
